import * as types from './UnreadActionType';

//Unread Exam Data - start
export const fetchUnreadExamDataRequest = (data) => ({
    type: types.FETCH_UNREAD_EXAM_DATA_REQUEST,
    payload: data
});
export const fetchUnreadExamDataSuccess = (data) => ({
    type: types.FETCH_UNREAD_EXAM_DATA_SUCCESS,
    payload: data
});
export const fetchUnreadExamDataFailure = (error) => ({
    type: types.FETCH_UNREAD_EXAM_DATA_FAILURE,
    payload: error
});
//Unread Exam Data - end